/**
 * @desc 盘点误差统计报表-导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inventoryMaster.exportInventoryError.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inventoryMaster/exportInventoryError`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
